import { IResponsePaging } from '@dto/index.dto';

export const InitialTableValue: IResponsePaging<any> = {
  page: 0,
  limit: 0,
  total: 0,
  totalPage: 0,
  data: [],
};
